export const INVOICE_ENDPOINT = {
  GET_BY_DOC_NUM: "/api/invoice/search-by-doc-num/{REPLACE_WITH_ID}",
  GET_BY_REF_DOC_NUM: "/api/invoice/search-by-ref-doc-num",
  CREATE_SUBMIT_HTML: "/api/payment/v1/createSubmitHTML"
};

export const UI_ENDPOINT = {
  GET_HOME_MAIN_TEXT: "/api/ui/homeMain",
  GET_SEARCH_HELP_TEXT: "/api/ui/searchHelp",
  GET_GOVERNOR_NAME: "/api/ui/governorsName",
  GET_FINANCE_EMAIL: "/api/ui/financeEmail",
  GET_PP_MAX_MONTHS: "/api/ui/paymentPlanMaximumMonths",
  GET_PP_QUALIFYING_INVOICE_REFERENCE_PREFIX: "/api/ui/paymentPlanQualifyingInvoiceReferencePrefix",
  GET_PP_REQUEST_FORM_VERBIAGE: "/api/ui/paymentPlanRequestFormVerbiage",
  GET_PP_DOES_NOT_QUALIFY_VERBIAGE: "/api/ui/paymentPlanInvoiceDoesNotQualifyVerbiage",
  PAYMENT_PLAN_SIGNUP: "/api/paymentplans/signUp",
  GET_PP_SIGNUP_CONFIRMATION_HTML: "/api/ui/paymentPlanSignupConfirmationHTML"
};
